module.exports = __webpack_public_path__ + "img/join_1.45ce8586.jpg";